export default __webpack_public_path__ + "static/use-2-en-39fa5d9e8f3e54fd3b6d3bb03461e325.png";